var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { GetLocalUserInfo, IsInExtension, IsUserSignedIn, RemoveLocalUserInfo, RemoveUserInfoInExtension, SaveLocalUserInfo } from '../user-info';
import { LogMessage } from '../helper-func';
import { LoginWithGoogle } from '../screenshot/api';
import { EventNames } from '../constants';
const styleText = `
  .user-icon {
    cursor: pointer;
    width: 48px;
    height: 48px;
    border-radius: 30%;
  }
  .user-icon:hover {
    transform: scale(1.05);
    transition: transform 0.3s;
  }
`;
// Function to parse JWT token from LoginWithGoogle.
export function ParseJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
}
let UserStatus = class UserStatus extends LitElement {
    constructor() {
        super();
        this.userInfo = null;
        // If true, the "login with google" will not be shown and if
        // user is not login, show nothing.
        this.onlyShowIcon = false;
        if (IsInExtension()) {
            // TODO Unify the code to look the local user info in extension.
        }
        else {
            const userInfo = GetLocalUserInfo();
            if (IsUserSignedIn(userInfo)) {
                LogMessage(`Loaded user info: ${JSON.stringify(userInfo)}`);
                this.userInfo = userInfo;
            }
        }
    }
    clearUserInfo() {
        this.userInfo = null;
        if (IsInExtension()) {
            RemoveUserInfoInExtension();
        }
        else {
            RemoveLocalUserInfo();
        }
    }
    updateUserInfo(userInfo) {
        this.userInfo = userInfo;
    }
    connectedCallback() {
        super.connectedCallback();
        const style = document.createElement('style');
        style.textContent = styleText;
        document.head.appendChild(style);
    }
    render() {
        return html `
      ${this.renderLoginWithGoogle()}
      ${this.userInfo
            ? html `${this.renderUserProfileImg()}`
            : nothing}
    `;
    }
    renderUserProfileImg() {
        return html `
    <div>
      <img
      src=${this.userInfo.iconUrl}
      class="user-icon"
      @click="${this.handleUserIconClick}"
      />
    </div>`;
    }
    renderLoginWithGoogle() {
        if (this.onlyShowIcon) {
            return nothing;
        }
        // @ts-ignore
        window.handleLoginWithGoogle = this.handleLoginWithGoogle.bind(this);
        return html `
      <div style="margin-top:1px; ${this.userInfo ? 'display: none;' : ''}">
        <div id="g_id_onload" data-client_id="964945452220-r1cpgaduu82tccbqq95i5c7mih92s1fb.apps.googleusercontent.com"
          data-context="signin" data-ux_mode="popup" data-callback="handleLoginWithGoogle"  data-auto_prompt="false">
        </div>
        <div class="g_id_signin" data-type="standard" data-shape="pill" data-theme="filled_blue" data-text="signin_with"
          data-size="large" data-logo_alignment="left">
        </div>
      </div>
    `;
    }
    createRenderRoot() {
        return this;
    }
    // called in data-callback
    handleLoginWithGoogle(response) {
        // Implement Google login logic here
        const profile = ParseJwt(response.credential);
        LogMessage(`handleLoginWithGoogle: ${JSON.stringify(profile)}`);
        // Call API to login and save userToken and iconUrl
        LoginWithGoogle(profile.email, profile.sub, profile.picture, profile.name, (success, data) => {
            LogMessage(`Successfully Login: ${JSON.stringify(data)}`);
            if (!success || !('token' in data)) {
                alert('Failed to sign in with Google!');
                return;
            }
            const userInfo = {
                userToken: data['token'],
                iconUrl: data['icon'],
                userName: data['name'],
                quotaEndTime: data['quota_end_time'],
            };
            LogMessage(`Save user info to local: ${JSON.stringify(userInfo)}`);
            SaveLocalUserInfo(userInfo);
            this.userInfo = userInfo;
            const event = new CustomEvent(EventNames.UserSignedIn, {
                detail: userInfo,
                bubbles: true,
                composed: true,
            });
            LogMessage('dispatch user-login event');
            this.dispatchEvent(event);
        });
    }
    handleUserIconClick() {
        LogMessage('_handleUserIconClick');
        this.dispatchEvent(new CustomEvent(EventNames.UserIconClicked, {
            bubbles: true,
            composed: true,
        }));
    }
};
__decorate([
    property({ attribute: false })
], UserStatus.prototype, "userInfo", void 0);
__decorate([
    property({ type: Boolean })
], UserStatus.prototype, "onlyShowIcon", void 0);
UserStatus = __decorate([
    customElement('user-status')
], UserStatus);
export { UserStatus };
